import { createFileRoute } from "@tanstack/react-router";
import AdminPushPage from "@/admin/pages/push";

const TABS = new Set(["push", "sent", "subscriptions", "health"]);

type AdminPushSearch = {
  tab?: "push" | "sent" | "subscriptions" | "health";
};

export const Route = createFileRoute("/admin/push/")({
  component: AdminPushPage,
  validateSearch: (search: Record<string, unknown>): AdminPushSearch => ({
    tab:
      typeof search.tab === "string" && TABS.has(search.tab)
        ? (search.tab as AdminPushSearch["tab"])
        : undefined,
  }),
});
